import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {apiURI} from '../config.js';
import Bugsnag from '@bugsnag/expo';
import {PivotLogging} from './cbcLoggingSlice.js';

/** STATE OBJECT */
const initialState = {
    loading_msg: 'idle',
    results_msg: '',
    messages: ''
};

export const checkReminderMessages = createAsyncThunk(
    'reminderActions/checkReminderMessages',
    async (userId, {rejectWithValue, dispatch}) => {
        try {
            const postData = {user_id: userId};
            const response = await fetch(`${apiURI}/fetch-reminder-messages.php`, {
                method: 'POST',
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify(postData)
            });

            const results = await response.json();
            console.log('results' , results);
            return results;

        } catch (error) {
            Bugsnag.notify(error);
            console.log('fetch reminderMessages complete: ' , results);
            return rejectWithValue('An unexpected error occurred');
        }
    }
);

/** DEFINE REDUCERS */
export const reminderActionsSlice = createSlice({
    name: 'reminderActions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checkReminderMessages.pending, (state) => {
                state.loading_msg = 'pending';
                state.results_msg = 'Attempting to fetch reminder messages';
            })
            .addCase(checkReminderMessages.fulfilled, (state, {payload}) => {
                state.loading_msg = 'idle';
                state.results_msg = 'Successfully fetched reminder messages.';
                AsyncStorage.setItem('reminderMessages', JSON.stringify(payload));
                state.messages = payload;
            })
            .addCase(checkReminderMessages.rejected, (state, {payload}) => {
                state.loading_msg = 'failed';
                state.results_msg = payload;
                console.log(payload);
            });
    },
});

// extract the reducer from the slice
const {reducer} = reminderActionsSlice;

// export the reducer
export default reducer;
